import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const useSessionCheck = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkSession = () => {
      const token = localStorage.getItem("token");
      const publicRoutes = ["/login", "/loginSupAdmin", "/forgot-password"];
      if (
        !token &&
        !publicRoutes.includes(location.pathname) &&
        !location.pathname.startsWith("/password-reset/")
      ) {
        navigate("/login");
      }
    };

    // Check session on component mount
    checkSession();

    // Add an event listener for changes in localStorage (specifically when 'token' is removed)
    window.addEventListener("storage", checkSession);

    return () => {
      window.removeEventListener("storage", checkSession);
    };
  }, [navigate]);
};

export default useSessionCheck;
